import {MatGoogleMapsAutocompleteModule} from '@angular-material-extensions/google-maps-autocomplete';
import {CommonModule, DatePipe, DecimalPipe} from '@angular/common';
import {NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { MatListModule } from "@angular/material/list";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from "@angular/material/expansion";
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTableModule} from '@angular/material/table';
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {TextMaskModule} from "angular2-text-mask";
import {PapaParseModule} from 'ngx-papaparse';
import {ActionableNotificationComponent} from "./_components/actionable-notification/actionable-notification.component";
import {AddDiscountComponent} from './_components/add-discount/add-discount.component';
import {BreadcrumbBarComponent} from './_components/breadcrumb-bar/breadcrumb-bar.component';
import {BulkVehicleUploadComponent} from './_components/bulk-vehicle-upload/bulk-vehicle-upload.component';
import {ConfirmAndBookComponent} from './_components/confirm-and-book/confirm-and-book.component';
import {ConfirmDialogContentComponent} from "./_components/confirm-dialog-content/confirm-dialog-content.component";
import {ContactSearchSelectorComponent} from "./_components/contact-search-selector/contact-search-selector.component";
import {DeprecatedLocationSelectorComponent} from './_components/deprecated-location-selector/deprecated-location-selector.component';
import {DiagWizardComponent} from "./_components/diag-wizard/diag-wizard.component";
import {DiagWizardDirective} from "./_components/diag-wizard/diag-wizard.directive";
import {DignifiInfoModalComponent} from './_components/dignifi-info-modal/dignifi-info-modal.component';
import {DisplayPriceComponent} from "./_components/display-price/display-price.component";
import {EmployeeAssignerComponent} from './_components/employee-assigner/employee-assigner.component';
import {ErrorMatCardComponent} from "./_components/error-mat-card/error-mat-card.component";
import {ErrorRouteAwayComponent} from './_components/error-route-away/error-route-away.component';
import {ErrorComponent} from "./_components/error/error.component";
import {HeaderComponent} from './_components/header/header.component';
import {InfoBannerComponent} from './_components/info-banner/info-banner.component';
import {JobRequestTableComponent} from "./_components/job-request-table/job-request-table.component";
import {JobTableComponent} from "./_components/job-table/job-table.component";
import {LicenseLookupComponent} from './_components/license-lookup/license-lookup.component';
import {LoginModalComponent} from "./_components/login-modal/login-modal.component";
import {LoginComponent} from './_components/login/login.component';
import {MarketingBlurbComponent} from './_components/marketing-blurb/marketing-blurb.component';
import {MarketingSecondaryBlurbComponent} from './_components/marketing-secondary-blurb/marketing-secondary-blurb.component';
import {MatListCheckboxComponent} from './_components/mat-list-checkbox/mat-list-checkbox.component';
import {MechanicModalComponent} from './_components/mechanic-modal/mechanic-modal.component';
import {MessageModalComponent} from "./_components/message-modal/message-modal.component";
import {ModalComponent} from './_components/modal/modal.component';
import {ModalDirective} from "./_components/modal/modal.directive";
import {NewLocationSharedComponent} from './_components/new-location-shared/new-location-shared.component';
import {PaymentMethodSelectorComponent} from './_components/payment-method-selector/payment-method-selector.component';
import {PhotoThumbnailsComponent} from './_components/photo-thumbnails/photo-thumbnails.component';
import {PhotoUploadComponent} from "./_components/photos/photo-upload.component";
import {PhotosComponent} from "./_components/photos/photos.component";
import {ServiceSchedulerComponent} from "./_components/service-scheduler/service-scheduler.component";
import {ServicesListBottomSheetComponent} from "./_components/services-list-bottom-sheet/services-list-bottom-sheet.component";
import {SignupModalComponent} from "./_components/signup-modal/signup-modal.component";
import {SignupComponent} from './_components/signup/signup.component';
import {SnackBarNotificationComponent} from './_components/snack-bar-notification/snack-bar-notification.component';
import {SubheaderComponent} from './_components/subheader/subheader.component';
import {SuccessMatCardComponent} from "./_components/success-mat-card/success-mat-card.component";
import {ValidatePromptComponent} from './_components/validate-prompt/validate-prompt.component';
import {VehicleEditLabelModalComponent} from "./_components/vehicle-edit-label-modal/vehicle-edit-label-modal.component";
import {VehicleDataSourceService} from "./_components/vehicle-search-selector/vehicle-data-source.service";
import {VehicleSearchSelectorComponent} from "./_components/vehicle-search-selector/vehicle-search-selector.component";
import {VinLookupComponent} from './_components/vin-lookup/vin-lookup.component';
import {WaitingTextComponent} from './_components/waiting-text/waiting-text.component';
import {WarningModalComponent} from "./_components/warning-modal/warning-modal.component";
import {WrenchConfirmationModalComponent} from "./_components/wrench-confirmation-modal/wrench-confirmation-modal.component";
import {WrenchMessageMatCardComponent} from "./_components/wrench-message-mat-card/wrench-message-mat-card.component";
import {WrenchMessageComponent} from "./_components/wrench-message/wrench-message.component";
import {WrenchModalDualButtonFooterComponent} from './_components/wrench-modal-dual-button-footer/wrench-modal-dual-button-footer.component';
import {WrenchModalHeaderComponent} from './_components/wrench-modal-header/wrench-modal-header.component';
import {WrenchModalSingleButtonFooterComponent} from './_components/wrench-modal-single-button-footer/wrench-modal-single-button-footer.component';
import {WrenchModalTripleButtonFooterComponent} from "./_components/wrench-modal-triple-button-footer/wrench-modal-triple-button-footer.component";
import {WrenchModalComponent} from './_components/wrench-modal/wrench-modal.component';
import {WrenchSpinnerComponent} from "./_components/wrench-spinner/wrench-spinner.component";
import {WrenchSubheaderComponent} from './_components/wrench-subheader/wrench-subheader.component';
import {YearMakeModelSelectorComponent} from './_components/year-make-model-selector/year-make-model-selector.component';
import {DigitOnlyDirective} from "./_directives/digit-only.directive";
import {EventTrackingDirective} from './_directives/event-tracking.directive';
import {HideInAppDirective} from './_directives/hide-in-app.directive';
import {InputTrimDirective} from './_directives/input-trim.directive';
import {PasswordMatcherDirective} from "./_directives/password-matcher.directive";
import {SiteLinkDirective} from './_directives/site-link.directive';
import {ValidateEqualDirective} from "./_directives/validate-equal.directive";
import {WrenchHideInWebDirective} from './_directives/wrench-hide-in-web.directive';
import {AddPipe} from "./_pipes/add.pipe";
import {CentPricePipe} from "./_pipes/cent-price.pipe";
import {ChecklistRangeUnitPipe} from './_pipes/checklist-range-unit.pipe';
import {ContactDisplayPipe} from "./_pipes/contact-display.pipe";
import {DataPhotoSrcPipe} from "./_pipes/data-photo-src.pipe";
import {DisplayNewLinesPipe} from "./_pipes/display-new-lines.pipe";
import {DollarPricePipe} from "./_pipes/dollar-price.pipe";
import {EcommerceProductsPipe} from "./_pipes/ecommerce-products.pipe";
import {FilterByContactPipe} from "./_pipes/filter-by-contact.pipe";
import {FilterByVehiclePipe} from "./_pipes/filter-by-vehicle.pipe";
import {FullAddressPipe} from "./_pipes/full-address.pipe";
import {ListStringsPipe} from "./_pipes/list-strings.pipe";
import {MarkdownPipe} from "./_pipes/markdown.pipe";
import {PaymentAliasPipe} from "./_pipes/payment-alias.pipe";
import {PrettyDurationPipe} from "./_pipes/pretty-duration.pipe";
import {ServiceFilterPipe} from "./_pipes/service-filter.pipe";
import {TruncateTextPipe} from "./_pipes/truncate-text.pipe";
import {VehicleDisplayPipe} from "./_pipes/vehicle-display.pipe";
import {VehicleYearMakeModelDisplayPipe} from "./_pipes/vehicle-year-make-model-display.pipe";
import {PagerService} from './_services';
import {WrenchModalContentDirective} from './wrench-modal-content.directive';
import {WrenchModalFooterDirective} from './wrench-modal-footer.directive';
import {WrenchModalHeaderDirective} from './wrench-modal-header.directive';
import {FullNamePipe} from "./_pipes/full-name.pipe";
import {DragDropDirective} from "./_directives/drag-drop.directive";
import {TransmissionPipe} from "./_pipes/transmission.pipe";
import {DrivetrainPipe} from "./_pipes/drivetrain.pipe";
import {SmallScreenWarningComponent} from "./_components/small-screen-warning/small-screen-warning.component";
import {MatTableResponsiveModule} from "./_directives/mat-table-responsive/mat-table-responsive.module";
import { CustomMinDirective } from './_directives/min-number.directive';
import {MechanicMapModalComponent} from "./_components/mechanic-map-modal/mechanic-map-modal.component";
import {InProgressComponent} from "./_components/in-progress/in-progress.component";
import {MapComponent} from "./_components/map/map.component";
import {AgmCoreModule} from "@agm/core";
import {StarRatingComponent} from "./_components/star-rating/star-rating.component";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import {WarningComponent} from "./_components/warning/warning.component";
import {SchedulingWindowsModule} from "../scheduling-windows/scheduling-windows.module";
import { API_KEYS } from 'app/core/constants';
import {WorkOrderStatusPipe} from "./_pipes/work-order-status.pipe";
import {ConfirmModalComponent} from "./_components/confirm-modal/confirm-modal.component";
import {PaymentModule} from "../payment/payment.module";
import {ErrorsModule} from "../widgets/errors/errors.module";
import {ListServicesPipe} from "./_pipes/list-services.pipe";
import {FullPageSpinnerComponent} from "../full-page-spinner/full-page-spinner.component";
import {CamelCaseToStringPipe} from "./_pipes/camel-case.pipe";
import {PpmContractStatusPipe} from "./_pipes/ppm-contract-status.pipe";
import {MatTooltipModule} from "@angular/material/tooltip";

const pipes = [
    AddPipe,
    CentPricePipe,
    ListServicesPipe,
    ChecklistRangeUnitPipe,
    ContactDisplayPipe,
    DataPhotoSrcPipe,
    DisplayNewLinesPipe,
    DollarPricePipe,
    EcommerceProductsPipe,
    FilterByContactPipe,
    FilterByVehiclePipe,
    FullAddressPipe,
    FullNamePipe,
    ListStringsPipe,
    MarkdownPipe,
    PaymentAliasPipe,
    PrettyDurationPipe,
    ServiceFilterPipe,
    TruncateTextPipe,
    VehicleDisplayPipe,
    VehicleYearMakeModelDisplayPipe,
    TransmissionPipe,
    DrivetrainPipe,
    MapComponent,
    WorkOrderStatusPipe,
    PpmContractStatusPipe
];

@NgModule({
    declarations: [
        ...pipes,
        PhotosComponent,
        ValidateEqualDirective,
        PasswordMatcherDirective,
        DigitOnlyDirective,
        CustomMinDirective,
        EventTrackingDirective,
        ErrorComponent,
        SuccessMatCardComponent,
        ErrorMatCardComponent,
        WrenchMessageComponent,
        WrenchMessageMatCardComponent,
        ServiceSchedulerComponent,
        LoginModalComponent,
        SignupModalComponent,
        VehicleSearchSelectorComponent,
        ContactSearchSelectorComponent,
        BreadcrumbBarComponent,
        WarningModalComponent,
        MessageModalComponent,
        ModalComponent,
        ModalDirective,
        BulkVehicleUploadComponent,
        LicenseLookupComponent,
        VinLookupComponent,
        MechanicModalComponent,
        MarketingBlurbComponent,
        MarketingSecondaryBlurbComponent,
        PaymentMethodSelectorComponent,
        PhotoThumbnailsComponent,
        VehicleEditLabelModalComponent,
        WrenchSubheaderComponent,
        ValidatePromptComponent,
        SiteLinkDirective,
        HideInAppDirective,
        WrenchHideInWebDirective,
        DignifiInfoModalComponent,
        SnackBarNotificationComponent,
        SubheaderComponent,
        HeaderComponent,
        DeprecatedLocationSelectorComponent,
        ConfirmAndBookComponent,
        NewLocationSharedComponent,
        EmployeeAssignerComponent,
        InputTrimDirective,
        ErrorRouteAwayComponent,
        AddDiscountComponent,
        DiagWizardComponent,
        DiagWizardDirective,
        PhotoUploadComponent,
        WrenchModalComponent,
        WrenchModalHeaderComponent,
        WrenchModalSingleButtonFooterComponent,
        WrenchModalHeaderDirective,
        WrenchModalContentDirective,
        WrenchModalFooterDirective,
        LoginComponent,
        SignupComponent,
        WaitingTextComponent,
        WrenchModalDualButtonFooterComponent,
        WrenchModalTripleButtonFooterComponent,
        InfoBannerComponent,
        MatListCheckboxComponent,
        InfoBannerComponent,
        WrenchConfirmationModalComponent,
        YearMakeModelSelectorComponent,
        JobRequestTableComponent,
        ServicesListBottomSheetComponent,
        ConfirmDialogContentComponent,
        JobTableComponent,
        WrenchSpinnerComponent,
        ActionableNotificationComponent,
        FullAddressPipe,
        ActionableNotificationComponent,
        DragDropDirective,
        TransmissionPipe,
        DrivetrainPipe,
        SmallScreenWarningComponent,
        DisplayPriceComponent,
        MechanicMapModalComponent,
        InProgressComponent,
        MapComponent,
        StarRatingComponent,
        WarningComponent,
        ConfirmModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TextMaskModule,
        PapaParseModule,
        RouterModule,
        MatDatepickerModule,
        MatChipsModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatButtonModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatCardModule,
        MatTableModule,
        MatDividerModule,
        MatExpansionModule,
        MatMenuModule,
        MatDialogModule,
        MatBottomSheetModule,
        MatSnackBarModule,
        MatRadioModule,
        MatListModule,
        MatSortModule,
        MatPaginatorModule,
        MatTableModule,
        FontAwesomeModule,
        MatGoogleMapsAutocompleteModule,
        MatTableResponsiveModule,
        MatProgressSpinnerModule,
        AgmCoreModule.forRoot({
            apiKey: API_KEYS.GOOGLE_MAPS
        }),
        NgxIntlTelInputModule,
        SchedulingWindowsModule,
        PaymentModule,
        ErrorsModule,
        FullPageSpinnerComponent,
        CamelCaseToStringPipe,
        MatTooltipModule,
    ],
    exports: [
        ...pipes,
        DatePipe,
        CommonModule,
        FormsModule,
        TextMaskModule,
        PhotosComponent,
        PasswordMatcherDirective,
        DigitOnlyDirective,
        CustomMinDirective,
        EventTrackingDirective,
        ErrorComponent,
        SuccessMatCardComponent,
        ErrorMatCardComponent,
        WrenchMessageComponent,
        WrenchMessageMatCardComponent,
        ValidateEqualDirective,
        ServiceSchedulerComponent,
        LoginModalComponent,
        SignupModalComponent,
        VehicleSearchSelectorComponent,
        ContactSearchSelectorComponent,
        BreadcrumbBarComponent,
        WarningModalComponent,
        MessageModalComponent,
        ModalComponent,
        ModalDirective,
        BulkVehicleUploadComponent,
        LicenseLookupComponent,
        VinLookupComponent,
        MarketingBlurbComponent,
        MarketingSecondaryBlurbComponent,
        PaymentMethodSelectorComponent,
        PhotoThumbnailsComponent,
        VehicleEditLabelModalComponent,
        WrenchSubheaderComponent,
        SiteLinkDirective,
        HideInAppDirective,
        WrenchHideInWebDirective,
        SnackBarNotificationComponent,
        SubheaderComponent,
        HeaderComponent,
        DeprecatedLocationSelectorComponent,
        NewLocationSharedComponent,
        EmployeeAssignerComponent,
        InputTrimDirective,
        AddDiscountComponent,
        LoginComponent,
        WaitingTextComponent,
        InfoBannerComponent,
        MatListCheckboxComponent,
        WrenchConfirmationModalComponent,
        YearMakeModelSelectorComponent,
        JobRequestTableComponent,
        ConfirmDialogContentComponent,
        ServicesListBottomSheetComponent,
        JobTableComponent,
        WrenchSpinnerComponent,
        ActionableNotificationComponent,
        FullAddressPipe,
        ActionableNotificationComponent,
        ReactiveFormsModule,
        DragDropDirective,
        TransmissionPipe,
        DrivetrainPipe,
        SmallScreenWarningComponent,
        DisplayPriceComponent,
        MechanicMapModalComponent,
        InProgressComponent,
        MapComponent,
        StarRatingComponent,
        WarningComponent,
        PhotoUploadComponent,
        ConfirmModalComponent
    ],
    providers: [
        ...pipes,
        DatePipe,
        DecimalPipe,
        PagerService,
        VehicleDataSourceService,
    ]
})

export class SharedModule {}
